import { Column } from '@access-erp/common';
import { CellType, FilterValueTypes } from '@access-erp/ui-components';

import { guidFilterOptions } from '@/components/common/EnquiriesScreen/utils/filters.config';

export interface UseTransactionTableColumnsReturn {
  headerColumns: Column<any>[];
}

export const getHeaderColumns = (): Column<any>[] => [
  {
    name: 'id',
    caption: 'Client Database ID',
    width: 300,
    cellType: CellType.String,
    defaultFilter: 1,
    groupable: false,
    disableRowGroup: true,
    filterType: FilterValueTypes.StringFilter,
    filterOptions: {
      availableOptions: guidFilterOptions,
    },
  },
  {
    name: 'name',
    caption: 'Client Database Name',
    width: 200,
    cellType: CellType.String,
    defaultFilter: 2,
    groupable: false,
    disableRowGroup: true,
  },
];
